import { styled } from "@mui/material";

export const Section = styled('div')(({ theme }) => (props) => ({
    // padding: '24px  96px',
    display: 'flex',
    width: '100%',
    gap: '5vw',
    padding: '0.4rem',
    justifyContent: 'space-between',
    [theme.breakpoints.down('md')]: {
        padding: '24px  48px',
    },
    [theme.breakpoints.down('sm')]: {
        padding: '12px ',
        flexDirection: 'column'
    },
    [theme.breakpoints.down('xs')]: {
        padding: '16px ',
    },
}))
export const RightSection = styled('div')(({ theme }) => (props) => ({
    flexDirection: 'column',
    width: '50%',
    [theme.breakpoints.down("md")]: {
        width: "100%"
    },
    [theme.breakpoints.down("sm")]: {
        width: "100%"
    }, [theme.breakpoints.down("xs")]: {
        width: "100%"
    }
}))

export const TitleSub = styled('p')(({ theme }) => (props) => ({
    margin: '0',
    fontSize: "24px",
    fontWeight: 800,
    color: theme.palette.mode === "light" ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px'
    }
}))
export const SubDisc = styled('p')(({ theme }) => (props) => ({
    fontSize: "16px",
    fontWeight: 400,
    margin: '5px  0',
    color: theme.palette.mode === "light" ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('lg')]: {
        fontSize: '1.8vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px'
    }
}))
export const HeadSection = styled('span')(({ theme }) => (props) => ({
    fontSize: '1.8vw',
    fontWeight: 800,
    lineHeight: '29px',
    letterSpacing: '0em',
    display: 'inline',
    margin: '0 10px',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '20px',
    }
}))
export const DiscContent = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    display: 'block',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('lg')]: {
        fontSize: "1.5vw",
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '12px',
    }
}))
export const SubTitle = styled('p')(({ theme }) => (props) => ({
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '20px',
    display: 'block',
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: "1.5vw",
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '14px',
    }
}))
export const TitleSkill = styled('span')(({ theme }) => (props) => ({
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '20px',
    display: 'inline-block',
    padding: ' 5px 15px',
    borderRadius: "42%",
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
    background: theme.palette.mode === "light" ? theme.palette.background.lightSecondary : theme.palette.darkSecondary,
    [theme.breakpoints.down('lg')]: {
        fontSize: "1.2vw",
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '1.7vw',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '10px',
    },
}))
export const SkillsPart = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    gap: '10px',
    [theme.breakpoints.down('xs')]: {
        maxWidth: '310px',
        overflowY: 'hidden',
        overflowX: 'auto',
        paddingBottom: '10px'
    }
}))
